/*
 * @FileName       : ui.reducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : UI reducer to handle UI events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import createReducer from './createReducer';
import { OrderActions } from '../actions';
import { ORDER } from '../constants/actions';
import { create, all } from 'mathjs';

const math = create(all, { number: 'BigNumber', precision: 20 });

export const order = createReducer(
	{},
	{
		[ORDER.SET_ORDER_DETAILS](state = {}, action: ReturnType<typeof OrderActions.setOrderDetails>) {
			return { ...state, orderDetails: action.payload };
		},

		[ORDER.SET_ALL_ORDER_LINE_ITEMS](state = {}, action: ReturnType<typeof OrderActions.setOrderDetails>) {
			return { ...state, allOrderLineItems: action.payload };
		},

		[ORDER.SET_ORDER_QUANTITY](state = {}, action: ReturnType<typeof OrderActions.setOrderQuantity>) {
			return { ...state, orderQuantity: action.payload };
		},

		[ORDER.SET_ORDER_WALL_UNIT_QUANTITY](state = {}, action: ReturnType<typeof OrderActions.setOrderWallUnitQuantity>) {
			return { ...state, orderWallUnitQuantity: action.payload };
		},

		[ORDER.SET_SHIPPING_LIST](state = {}, action: ReturnType<typeof OrderActions.setShippingList>) {
			return { ...state, orderShippingList: action.payload };
		},

		
  [ORDER.SET_NARCAN_QUANTITY](state = {}, action: ReturnType<typeof OrderActions.setNarcanQuantity>) {
    return { ...state, narcanQuantity: action.payload }
  },

  [ORDER.SET_NARCAN_CHECKED](state = {}, action: ReturnType<typeof OrderActions.setNarcanChecked>) {
    return { ...state, narcanChecked: action.payload }
  },

  [ORDER.SET_AUTO_CALC_NARCAN_CHECKED](state = {}, action: ReturnType<typeof OrderActions.setAutoCalcNarcanChecked>) {
    return { ...state, autoCalcNarcanChecked: action.payload }
  },

		/*** MISNOMER: "tax rate" is really the numerical tax AMOUNT *****/
// 	[ORDER.SET_TAX_RATE](state = {}, action: ReturnType<typeof OrderActions.setTaxRate>) {
// 		if (!action.payload || !action.payload.length) {
// 			return { ...state, taxRate: 0 };
// 		}

// 		//if (Object.keys(action.payload.length > 0)) {
// 			let totalTaxAmount = 0;

// //*****PROBLEM HERE!!! RMM 4/7
			
// 			for (let i = 0; i < action.payload[0].taxLineItems?.length; i++) {
// 				const thisTaxObj = action.payload[0].taxLineItems[i];
// 				totalTaxAmount += Number(thisTaxObj?.tax?.amount_to_collect) || 0;				
// 			}

// 			return { ...state, taxRate: math.round(totalTaxAmount, 2) };
// 		// 	}

// 		// return { ...state, taxRate: 0 };
// 	},

	[ORDER.SET_TAX_RATE](state = {}, action: ReturnType<typeof OrderActions.setTaxRate>) {
    return { ...state, taxRate: action.payload }
  },

		[ORDER.SET_TAX_RATE_LOADED](state = {}, action: ReturnType<typeof OrderActions.setTaxRateLoaded>) {
			return { ...state, taxRateLoaded: action.payload };
		},

		[ORDER.CLEAR_TAX_RATE](state = {}, action: ReturnType<typeof OrderActions.clearTaxRate>) {
			return { ...state, taxRate: 0, taxRateLoaded: false };
		},

		[ORDER.SHOW_TAX_LOADER](state = {}, action: ReturnType<typeof OrderActions.showTaxLoader>) {
			return { ...state, isTaxLoading: action.payload };
		},

		[ORDER.SET_VALIDATED_ADDRESSES](state = {}, action: ReturnType<typeof OrderActions.setValidatedAddresses>) {
			return { ...state, validatedAddresses: action.payload };
		},

		[ORDER.SET_VALIDATED_TAX_RESULTS](state = {}, action: ReturnType<typeof OrderActions.setValidatedTaxResult>) {
			const validatedAddressList = [];
			const shipFromWarehouseMap: any = {};

			const address = action.payload[0].address;

			for (let i = 0; i < action.payload[0].taxLineItems.length; i++) {
				//put warehouse objs into `shipFromWarehouseMap` for easy retrival when needed
				shipFromWarehouseMap[action.payload[0].taxLineItems[i].productId] = action.payload[0].taxLineItems[i].shipFromWarehouse;


				if (action.payload[0].address) {
					validatedAddressList.push({
						shippingAddress: action.payload[0].address,
						isValid: true,
						tax: action.payload[0].taxLineItems[i].tax.amount_to_collect,
						shipFromWarehouse: action.payload[0].taxLineItems[i].shipFromWarehouse?.warehouse,
					});
				} 
				else {
					validatedAddressList.push({
						isValid: false,
						errorMessage: action.payload[i].error ? action.payload[i].detail : 'Error finding address',
					});
				}
			}
			
			return { ...state, 
						validatedTaxResult: validatedAddressList, 
						shipFromWarehouseMap: shipFromWarehouseMap
					};
		},

		[ORDER.SET_PRODUCT](state = {}, action: ReturnType<typeof OrderActions.setProduct>) {
			return { ...state, products: action.payload };
		},

		[ORDER.SET_TOKEN](state = {}, action: ReturnType<typeof OrderActions.setToken>) {
			return { ...state, ccToken: action.payload };
		},

		[ORDER.SET_PAYMENT_INPUTS](state = {}, action: ReturnType<typeof OrderActions.setPaymentInputs>) {
			return { ...state, paymentInputs: action.payload };
		},

		[ORDER.CLEAR_PAYMENT_INPUTS](state = {}, action: ReturnType<typeof OrderActions.clearPaymentInputs>) {
			return {
				...state,
				paymentInputs: {
					shippingAddress: '',
					shippingAddress2: '',
					shippingCity: '',
					shippingState: '',
					shippingZip: '',
					billingAddress: '',
					billingAddress2: '',
					billingCity: '',
					billingState: '',
					billingZip: '',
					name: '',
					email: '',
					phoneNumber: '',
				},
			};
		},
	},
);
